import styled, { css } from 'styled-components';
import createRichTextPanel from './richTextPanelFormatHelper';
import { RICH_TEXT_ALIGNMENT } from '../../../enums';
import React from 'react';
import { theme } from '../../../theme';

const RichTextPanelContainer = styled.section<{
  $textAlignment: RICH_TEXT_ALIGNMENT;
}>`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 12px;

  h2 {
    margin: 0;
    ${theme.typography.headings[2]['xs-md']};
    ${theme.typography.headings[2]['md-xl']};
    ${theme.typography.headings[2]['xl']};
  }

  h3 {
    margin: 0;
    ${theme.typography.headings[3]['xs-md']};
    ${theme.typography.headings[3]['md-xl']};
    ${theme.typography.headings[3]['xl']};
  }

  h4 {
    margin: 0;
    ${theme.typography.headings[4]['xs-md']};
    ${theme.typography.headings[4]['md-xl']};
    ${theme.typography.headings[4]['xl']};
  }

  h5 {
    margin: 0;
    ${theme.typography.headings[5]['xs-md']};
    ${theme.typography.headings[5]['md-xl']};
    ${theme.typography.headings[5]['xl']};
  }

  .link {
    color: ${theme.colors.primary.graysBlue};
  }

  ${({ $textAlignment }) =>
    $textAlignment === RICH_TEXT_ALIGNMENT.CENTRE &&
    css`
      align-items: center;
      text-align: center;
    `}

  ${({ $textAlignment }) =>
    $textAlignment === RICH_TEXT_ALIGNMENT.RIGHT &&
    css`
      align-items: end;
    `}
`;

export type RichTextProps = {
  label: string;
  content: any;
  textAlignment: RICH_TEXT_ALIGNMENT;
};

export const RichTextPanel = (data: RichTextProps): JSX.Element => {
  return (
    <RichTextPanelContainer $textAlignment={data.textAlignment}>
      {createRichTextPanel(data.content)}
    </RichTextPanelContainer>
  );
};
